import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoCreditcard16 = t0 => {
  const $ = _c(12);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== iconColor) {
    t2 = <path d="M3.68645 9.9395C3.68645 9.58051 3.97747 9.2895 4.33645 9.2895H6.4914C6.85039 9.2895 7.1414 9.58051 7.1414 9.9395C7.1414 10.2985 6.85039 10.5895 6.4914 10.5895H4.33645C3.97747 10.5895 3.68645 10.2985 3.68645 9.9395Z" fill={iconColor} />;
    t3 = <path d="M11.2322 9.2895C10.8733 9.2895 10.5822 9.58051 10.5822 9.9395C10.5822 10.2985 10.8733 10.5895 11.2322 10.5895H11.6629C12.0218 10.5895 12.3129 10.2985 12.3129 9.9395C12.3129 9.58051 12.0218 9.2895 11.6629 9.2895H11.2322Z" fill={iconColor} />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M3.47445 1.98764C2.17715 1.98764 1.12549 3.0393 1.12549 4.3366V11.6634C1.12549 12.9608 2.17716 14.0124 3.47445 14.0124H12.5252C13.8226 14.0124 14.8742 12.9608 14.8742 11.6634V4.3366C14.8742 3.03931 13.8226 1.98764 12.5252 1.98764H3.47445ZM2.37549 4.3366C2.37549 3.72966 2.86751 3.23764 3.47445 3.23764H12.5252C13.1322 3.23764 13.6242 3.72965 13.6242 4.3366V5.84146H2.37549V4.3366ZM2.37549 7.14146V11.6634C2.37549 12.2704 2.8675 12.7624 3.47445 12.7624H12.5252C13.1322 12.7624 13.6242 12.2704 13.6242 11.6634V7.14146H2.37549Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaLabel || $[7] !== className || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}{t4}</svg>;
    $[6] = ariaLabel;
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default IcoCreditcard16;